import { VERIFY_EMAIL, VERIFY_EMAIL_RESET } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface VerifyEmailResponse extends BaseAsyncReducerState{
    verified: boolean;
}   

// Define an initial state value for the app
const initialState: VerifyEmailResponse = {
    loading: false,
    error: false,
    verified: false,
}

function verifyEmailReducer(state = initialState, action: AppAction): VerifyEmailResponse | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case VERIFY_EMAIL.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                verified: false,
            }
        case VERIFY_EMAIL.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,
            }

        case VERIFY_EMAIL.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        
        case VERIFY_EMAIL_RESET:
            return {
                ...state,
                ...initialState
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default verifyEmailReducer;